module.exports = __webpack_public_path__ + "img/waiting.3db406a4.svg";